<!-- <div class="card parentcard p-3 overflow-y-auto">
  <div class="container-fluid" id="container">
    <div class="row header-txt m-0">
      <h6 class="pt-4">
        <strong>Step 1:</strong>
        <p class="">Select the Metadata Source</p>
        <hr />
      </h6>
    </div>
    <form>
      <div class="row">
        <div
          class="col-6 col-xs-6 col-sm-6 col-md-5 col-lg-5 col-xl-5 col-xxl-5"
        >
          <div class="form-container selectsec">
            <h5 class="mt-5"><i class="bi bi-database-check"></i></h5>
            <label for="options" class="mt-0 pt-0">
              <strong>
                <p>Select Node:</p>
              </strong>
            </label>
            <select
              id="options"
              class="form-select"
              name="select"
              [(ngModel)]="selectedDatabase"
              (change)="onDatabaseSelect($event)"
            >
              <option ngValue="None" selected>None</option>
              <option *ngFor="let dbName of databaseName" [value]="dbName.platform_name">
                {{ dbName.platform_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-1 col-lg-1 col-xl-1 col-xxl-1 text-center">
          <div class="vr mt-5 pt-5"></div>
        </div>
        <div
          class="col-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
        >
          <div class="form-container uploadsec">
            <h5 class="mt-5"><i class="bi bi-filetype-sql"></i></h5>
            <h6>
              <strong>
                <p>Upload file(s)</p>
              </strong>
            </h6>
            <input
              type="file"
              (change)="onFileSelected($event)"
              accept=".sql"
              multiple
              class="form-control mt-4"
              #fileInput
            />
            <div class="container table-contain mt-4">
              <table class="table align-middle table-striped table-hover border rounded-3" *ngIf="uploadedFiles.length > 0">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Database <span class="text-danger">*</span></th>
                    <th>Schema <span class="text-danger">*</span></th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let file of uploadedFiles; let i = index">
                    <td>{{ file.filename }}</td>
                    <td>
                      <input type="text" class="form-control" name="dbname" [(ngModel)]="file.database_name"  (ngModelChange)="updateButtonState()" placeholder="Enter Database name..." required>
                    </td>
                    <td >
                      <input type="text" class="form-control" name="schname" [(ngModel)]="file.schema_name" (ngModelChange)="updateButtonState()" placeholder="Enter Schema name..." required>
                    </td>
                    <td>
                      <button class="btn btn-link" (click)="viewFile(file)"><i class="bi bi-eye"></i></button>
                      <button class="btn btn-link text-danger" (click)="removeFile(i)"><i class="bi bi-trash"></i></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>


          </div>
        </div>
        <div class="row float-end justify-content-end">
          <button
            type="button"
            class="btn btn-primary nxtbtn"
            (click)="dbWorkflow()"
            [disabled]="nextButtonDisabled"

          >
            {{nextButtonText}}
            <i class="bi bi-arrow-right-square"></i>
          </button>
        </div>
      </div>

    </form>
  </div>
  <div
      class="toast-container position-fixed top-0 end-0 p-3"
      style="z-index: 1100"
    >
      <ngb-toast
        *ngFor="let toast of toastService.getToasts()"
        [autohide]="toast.options?.autohide ?? true"
        [delay]="toast.options?.delay ?? 5000"
        [class]="toast.options?.classname"
        (hidden)="toastService.remove(toast)"
      >
        <ng-template [ngIf]="toastService.isTemplate(toast)" [ngIfElse]="text">
          <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
        </ng-template>
        <ng-template #text>{{ toast.textOrTpl }}</ng-template>
      </ngb-toast>
    </div>
</div> -->

<div class="card parentcard p-3 overflow-y-auto">
  <div class="container-fluid" id="container">
    <div class="row header-txt m-0">
      <h6 class="pt-4">
        <strong>Step 1:</strong>
        <p class="">Select the Metadata Source</p>
        <hr />
      </h6>
    </div>
    <form>
      <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <div class="form-container selectsec">
            <h5 class="mt-5"><i class="bi bi-database-check"></i></h5>
            <label for="options" class="mt-0 pt-0">
              <strong>
                <p>Select Node:</p>
              </strong>
            </label>
            <select
              id="options"
              class="form-select"
              name="select"
              [(ngModel)]="selectedDatabase"
              (change)="onDatabaseSelect($event)"
            >
              <option ngValue="None" selected>None</option>
              <option *ngFor="let dbName of databaseName" [value]="dbName.platform_name">
                {{ dbName.platform_name }}
              </option>
            </select>
          </div>
        </div>
        
        <div class="row float-end justify-content-end">
          <button
            type="button"
            class="btn btn-primary nxtbtn"
            (click)="dbWorkflow()"
            [disabled]="nextButtonDisabled"
          >
            {{nextButtonText}}
            <i class="bi bi-arrow-right-square"></i>
          </button>
        </div>
      </div>
    </form>
  </div>
  
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1100">
    <ngb-toast
      *ngFor="let toast of toastService.getToasts()"
      [autohide]="toast.options?.autohide ?? true"
      [delay]="toast.options?.delay ?? 5000"
      [class]="toast.options?.classname"
      (hidden)="toastService.remove(toast)"
    >
      <ng-template [ngIf]="toastService.isTemplate(toast)" [ngIfElse]="text">
        <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
      </ng-template>
      <ng-template #text>{{ toast.textOrTpl }}</ng-template>
    </ngb-toast>
  </div>
</div>